import React from 'react';
import { Link } from 'react-router-dom';

export interface SyncResult {
  status: 'synced' | 'failed' | 'queued' | 'skipped';
  mode?: 'inline' | 'background';
  message?: string;
  sync_log_id?: number;
  shopify_product_id?: string | number | null;
}

interface Props {
  sync?: SyncResult | null;
  itemId?: number;
  className?: string;
}

/**
 * Tells the seller what happened on BookMarketLk after a save:
 * listed, queued for the worker, failed (with a retry link), or sync disabled.
 */
const SyncResultNotice: React.FC<Props> = ({ sync, itemId, className = '' }) => {
  if (!sync || sync.status === 'skipped') return null;

  if (sync.status === 'synced') {
    return (
      <p className={`flex items-center gap-2 text-sm text-green-800 ${className}`}>
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
        Listed on BookMarketLk — it is live on the store now.
      </p>
    );
  }
  if (sync.status === 'queued') {
    return (
      <p className={`text-sm text-gray-700 ${className}`}>
        Saved. It is being sent to BookMarketLk in the background and will appear on the store shortly.
      </p>
    );
  }
  return (
    <div className={`rounded-md bg-orange-50 border border-orange-200 p-3 text-sm text-orange-900 ${className}`}>
      <p className="font-medium">Saved to inventory, but listing on BookMarketLk failed.</p>
      {sync.message && <p className="mt-1 text-xs break-words">{sync.message}</p>}
      {itemId && (
        <Link to={`/inventory/${itemId}`} className="mt-1 inline-block font-medium underline">
          Open the item to retry
        </Link>
      )}
    </div>
  );
};

export default SyncResultNotice;
